import { render, staticRenderFns } from "./MonthyMag.vue?vue&type=template&id=786b1c69&scoped=true&"
import script from "./MonthyMag.vue?vue&type=script&lang=js&"
export * from "./MonthyMag.vue?vue&type=script&lang=js&"
import style0 from "./MonthyMag.vue?vue&type=style&index=0&id=786b1c69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b1c69",
  null
  
)

export default component.exports